import useSWR from 'swr';
import { SWRConfiguration } from 'swr';

/**
 * A custom hook that wraps useSWR to handle dependent fetching.
 * The fetch will only run when all dependencies are truthy.
 *
 * @param key The SWR key - will be null if dependencies are not met
 * @param fetcher The function to fetch data
 * @param dependencies Array of dependencies that must all be truthy
 * @param config Optional SWR configuration
 * @returns The SWR response
 */
export function useDependentSWR<T>(
  key: string | null,
  fetcher: () => Promise<T>,
  dependencies: any[],
  config?: SWRConfiguration
) {
  // Check if all dependencies are truthy
  const shouldFetch = dependencies.every(Boolean);

  return useSWR<T>(
    shouldFetch ? key : null,
    shouldFetch ? fetcher : null,
    config
  );
}
